import { render, staticRenderFns } from "./OvenAdd.vue?vue&type=template&id=6b0615d2&"
import script from "./OvenAdd.vue?vue&type=script&lang=js&"
export * from "./OvenAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports